import React from 'react';
import classnames from 'classnames';
import { T } from '@sm/intl';
import './mrx-header.scss';

export const COPY = {
  title: {
    id: 'mrx.MRXHeader.title',
    defaultMessage: 'Explore our market research solutions',
    description:
      '[Type: Header][Vis: med] - Page header for market research hub'
  },
  subtitle: {
    id: 'mrx.MRXHeader.subtitle',
    defaultMessage:
      'We’ve made it easy to quickly collect quality data from your target market. ' +
      'Choose from Expert Solutions, global online panels, or market research services to help you get answers, fast.',
    description:
      '[Type: Paragraph][Vis: med] - Description of the market research hub'
  }
};

export const TEST_ID = 'MRXHeader';

const MRXHeader = () => {
  const isIE = !!window.MSInputMethodContext && !!document.documentMode;
  const classes = classnames({
    'sm-mrx-header': !isIE,
    'sm-mrx-header--ie': isIE
  });
  return (
    <div className={classes} data-testid={TEST_ID}>
      <h1 className="sm-mrx-header__title">
        <T desc={COPY.title} />
      </h1>
      <div className="sm-mrx-header__subtitle">
        <T desc={COPY.subtitle} />
      </div>
    </div>
  );
};

export default MRXHeader;
